/**
 * Pear — approved legal copy (card cEchedAassmt).
 *
 * Verbatim from the Pear ⚙️ Ops Runbook §8 (Data / Backups / Legal), drafted
 * 2026-10-10 and APPROVED by Jonathan in chat on 2026-10-11 ("privacy terms
 * approved"). Standard template written by the PM, not legal advice — a
 * lawyer reads it before any public launch (scope caveat on the card).
 *
 * Editing this file edits the public policy text. If the Runbook §8 copy
 * changes, change it there first and mirror it here.
 *
 * Founder email 2026-10-23: name Together Connect Studios Pty Ltd as the
 * product entity and make support@togetherconnect.io the data-export /
 * contact address — mirrored in Runbook §8 the same day.
 */

export interface LegalDoc {
  slug: 'privacy' | 'terms';
  title: string;
  /** Small line under the title — provenance, not part of the approved body. */
  note: string;
  /** Approved body — paragraphs in order, wording unaltered. */
  paragraphs: string[];
}

export const PRIVACY: LegalDoc = {
  slug: 'privacy',
  title: 'Privacy Policy',
  note: 'Standard template — not legal advice. Last updated 23 October 2026.',
  paragraphs: [
    'Pear ("the app") is a product of Together Connect Studios Pty Ltd. We collect only what the app needs to work: your account email, the pairing link between the two partners, the content you and your partner add (notes, links, chores, dates, preferences), and basic usage events used to improve the app.',
    'Couple data is stored scoped to your account and is not sold, rented, or shared with advertisers. AI features send the relevant snippet of your content to our model provider to generate a response; it is not used to train public models.',
    'You can export or delete your data at any time by contacting support@togetherconnect.io — deletion removes your couple space permanently within 30 days. Analytics are privacy-preserving and can be opted out of in Settings.',
    'This policy applies to the AU and US launch regions; it will be updated if regions change.',
  ],
};

export const TERMS: LegalDoc = {
  slug: 'terms',
  title: 'Terms of Service',
  note: 'Standard template — not legal advice. Last updated 23 October 2026.',
  paragraphs: [
    'Pear is a product of Together Connect Studios Pty Ltd. By using Pear you agree to use it for personal, household purposes only for the two partners in your pair. Your account is shared by exactly two people; you are responsible for keeping your sign-in credentials secure.',
    'Pear Plus is a paid subscription ($9.99/month or $79.99/year) billed through our payment provider; you can cancel anytime and keep access until the end of the paid period.',
    'The app is provided "as is" without warranties — it helps you plan and remember, it is not a substitute for professional advice (financial, medical, or legal). We may update these terms with notice in the app.',
    'Questions, data export or termination requests: support@togetherconnect.io (Together Connect Studios Pty Ltd).',
  ],
};

/** Path → doc. main.tsx uses this to pick the screen; the footer uses it for hrefs. */
export function legalDocForPath(pathname: string): LegalDoc | null {
  const path = pathname.replace(/\/+$/, '') || '/';
  if (path === '/privacy') return PRIVACY;
  if (path === '/terms') return TERMS;
  return null;
}
